<template>
  <!-- NOTE (TEMPLATE) to show the researcher login page -->

  <div class="app animated fadeIn flex-row align-items-center resBack">
    <b-toast
      id="example-toast"
      title="شماره تلفن همراه و رمز عبور نادرست است"
      static
      no-auto-hide
      >شماره تلفن همراه و رمز عبور نادرست است</b-toast
    >

    <div class="container">
      <b-row class="justify-content-center">
        <h1 class="mb-5 text-white" style="color: #fff">
          پژوهشگر گرامی، به سامانه تقسیم کار ملی خوش آمدید!
        </h1>

        <b-col md="8" class="px-0">
          <b-card-group>
            <b-card no-body class="login-card p-4 pb-2">
              <b-card-header v-if="!sendCodeClicked || !codeSent">
                <b-button @click="swapLoginMode()">{{
                  codeLogin
                    ? "ورود با تلفن همراه و رمز عبور"
                    : "ورود با کد یکبارمصرف"
                }}</b-button>
              </b-card-header>

              <b-card-body v-if="codeLogin">
                <p class="text-muted">
                  لطفا برای ورود به سیستم و دریافت رمز عبور یکبار مصرف از طریق
                  پیامک،
                  <b>تلفن همراه</b> خود را وارد کنید.
                </p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-user"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>

                  <masked-input
                    dir="ltr"
                    type="text"
                    mask="\0911 111 1111"
                    v-model="username"
                    class="form-control"
                    placeholder="09__ ___ ____"
                    :disabled="codeSent"
                    @keyup.enter.native="!busy && username ? sendCode() : ''"
                  />
                </b-input-group>
                <b-input-group class="mb-4" v-if="codeSent">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    trim
                    type="number"
                    :no-wheel="true"
                    v-model="activationCode"
                    class="form-control"
                    placeholder="کد ارسالی"
                    autofocus
                    @keyup.enter.native="
                      !busy && activationCode ? gotoDashboard() : ''
                    "
                  />
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <!-- NOTE (b-sendCode) to register the number and receive the activation code -->
                    <b-button
                      v-if="!codeSent"
                      type="submit"
                      variant="primary"
                      @click="sendCode()"
                      style="border: 0"
                      :disabled="busy || !username"
                      class="btn-radius px-8 py-2 mt-4"
                    >
                      <i class="icon-login"></i>ارسال کد فعالسازی
                    </b-button>

                    <!-- NOTE (b-login) to go to the researcher dashboard -->
                    <b-button
                      v-if="codeSent"
                      type="submit"
                      variant="primary"
                      @click="gotoDashboard()"
                      style="border: 0"
                      :disabled="busy || !activationCode"
                      class="btn-radius px-8 py-2 mt-4"
                    >
                      <i class="icon-login"></i>ورود </b-button
                    >&nbsp;
                    <!-- NOTE (b-changeNumber) to go to the previous step and change the number -->
                    <b-button
                      v-if="codeSent"
                      type="submit"
                      variant="info"
                      @click="changeNumber()"
                      style="border: 0"
                      :disabled="busy"
                      class="btn-radius px-8 py-2 mt-4"
                    >
                      <b-icon icon="arrow-counterclockwise"></b-icon>تغییر تلفن
                      همراه
                    </b-button>
                  </b-col>
                  <b-col cols="6" class="text-left">
                    <!-- NOTE (b-sendAgain) to get the activation code again -->
                    <b-button
                      v-if="codeSent"
                      type="submit"
                      variant="info"
                      @click="resendCode()"
                      style="border: 0"
                      :disabled="sendAgainDisbaled"
                      class="btn-radius px-8 py-2 mt-4"
                    >
                      <b-icon icon="arrow-counterclockwise"></b-icon>ارسال مجدد
                      کد
                      <span v-if="countdown != 0">{{
                        toHHMMSS(countdown)
                      }}</span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
              <b-card-body v-else>
                <p class="text-muted">
                  لطفا شماره تلفن همراه و رمز عبور (پیشفرض شماره تلفن همراه) خود
                  را وارد کنید
                  <br />
                  <br />لطفا توجه داشته باشید که
                  <b
                    >برای فعالسازی ورود با رمز عبور، حداقل یک مرتبه ورود با کد
                    فعالسازی الزامی است</b
                  >.
                </p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-user"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-input
                    trim
                    type="text"
                    v-model="username"
                    class="form-control"
                    placeholder="شماره تلفن همراه"
                  />
                </b-input-group>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-key"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-input
                    trim
                    type="password"
                    v-model="password"
                    class="form-control"
                    placeholder="رمز عبور"
                    @keyup.enter.native="
                      !busyLogin && username && password ? login() : ''
                    "
                  />
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <!-- NOTE (b-login) to register the number and password and then login -->
                    <b-button
                      type="submit"
                      variant="primary"
                      @click="login()"
                      style="border: 0"
                      :disabled="busyLogin || !username || !password"
                      class="btn-radius px-8 py-2 mt-4"
                    >
                      <i class="icon-login"></i>ورود
                    </b-button>
                  </b-col>
                  <b-col cols="6" class="text-left"></b-col>
                </b-row>
              </b-card-body>
              <div>
                <b-row></b-row>
              </div>
            </b-card>
          </b-card-group>
          <b-row class="justify-content-center mt-5">
            <v-btn
              color="indigo lighten-2"
              @click="goTo('admin')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود مدیر
            </v-btn>
            <v-btn
              color="red darken-3"
              @click="goTo('ref')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود داور
            </v-btn>
            <v-btn
              color="deep-orange lighten-1"
              @click="goTo('accelerator')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود شتاب‌دهنده
            </v-btn>
            <v-btn
              color="indigo"
              @click="goTo('company')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود شرکت
            </v-btn>
            <v-btn
              color="teal"
              @click="goTo('uni')"
              class="m-1 white--text btn-radius"
              width="136"
              height="42"
              elevation="0"
            >
              ورود دانشگاه
            </v-btn>
          </b-row>
          <hr class="mt-6" />
          <b-row class="justify-content-center mt-3">
            <v-btn
              color="blue darken-1"
              to="/map"
              class="m-1 white--text btn-radius"
              height="42"
              elevation="0"
            >
              <v-icon class="me-1">mdi-map</v-icon>نقشه تعاملی زیست فناوری
            </v-btn>
            <v-btn
              color="yellow darken-1"
              class="m-1 black--text btn-radius"
              height="42"
              elevation="0"
              @click="faqDialog = true"
            >
              <v-icon class="me-1">mdi-frequently-asked-questions</v-icon>سوالات
              متداول
            </v-btn>
            <v-btn
              color="orange darken-1"
              href="https://api.biodcportal.com/setad/public/طرح%20تقسیم%20کار%20ملی%20زیست%20فناوری.pdf"
              class="m-1 white--text btn-radius"
              height="42"
              elevation="0"
            >
              راهنمای آشنایی با طرح تقسیم کار ملی زیست فناوری
            </v-btn>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <ChangeLog />
    <FaqDialogue :faq-dialog.sync="faqDialog" />
  </div>
</template>

<script>
import MaskedInput from "../../node_modules/vue-masked-input";
import md5 from "js-md5";
const FaqDialogue = () => import("../components/FaqDialogue");

export default {
  components: { MaskedInput, FaqDialogue },
  data() {
    return {
      name: "Login",
      username: "",
      password: "",
      activationCode: "",
      busy: false,
      busyLogin: false,

      codeSent: false,
      countdown: 0,
      timesup: true,
      codeLogin: true,
      sendCodeClicked: false,
      countdownGone: false,
      faqDialog: false,
    };
  },
  watch: {
    codeSent: function (val, oldVal) {
      // NOTE (w-codeSent) to give the code again after 60 second
      this.countdown = 60;

      if (val == true) {
        this.sendAgainDisbaled = true;
        !this.countdownGone ? this.countDownTimer() : 1;
      }
    },
    countdown: function (val, oldVal) {
      // NOTE (w-countdown) to countdown for sending code again
      if (val == 0) {
        this.sendAgainDisbaled = false;
      } else {
        this.sendAgainDisbaled = true;
      }
    },
  },
  computed: {
    // newTimer: new Date(),
  },
  methods: {
    goTo(role) {
      if (role == "admin") {
        this.$router.push("/adminloginsolid");
      } else if (role == "ref") {
        this.$router.push("/refloginsolid");
      } else if (role == "uni") {
        this.$router.push("/uniloginsolid");
      } else if (role == "company") {
        this.$router.push("/companyLoginsolid");
      } else if (role == "accelerator") {
        this.$router.push("/acceleratorLoginsolid");
      }
    },
    swapLoginMode() {
      this.username = "";
      this.codeLogin = !this.codeLogin;
    },
    toHHMMSS(value) {
      // NOTE (m-toHHMMSS) determine the order of hours, minutes and seconds
      var sec_num = parseInt(value, 10); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return minutes + ":" + seconds;
    },
    countDownTimer() {
      //NOTE (m-countDownTimer) to start counting down after 1 second
      this.countdownGone = true;
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    changeNumber() {
      // NOTE (m-changeNumber) to change the number
      this.countdown = 0;
      this.codeSent = false;
    },
    resendCode() {
      this.countdownGone = false;
      this.sendCode();
    },
    sendCode() {
      this.sendCodeClicked = true;
      this.username = this.username.split(" ").join("");
      // NOTE (m-sendCode) to send the code
      this.codeSent = false;
      this.busy = true;
      this.$http
        .post(this.baseUrl + "/setad/authentication/login", {
          mobile: this.username,
        })
        .then(() => {
          this.countdown = 60;
          this.codeSent = true;
          this.busy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },

    gotoDashboard() {
      // NOTE (m-gotoDashboard) to go to the dashboard
      this.busy = true;
      this.$http
        .post(this.baseUrl + "/setad/authentication/entrance", {
          mobile: this.username,
          activationcode: this.activationCode,
        })
        .then((res) => {
          if (res.status == 200) {
            localStorage.setItem("userId", res.data.token);

            localStorage.setItem("username", res.data.name);
            localStorage.setItem("role", "researcher");
            this.$route.query.return
              ? this.$router.push(this.$route.query.return)
              : this.$router.push("/researcher/dashboard");
          } else {
            this.busy = false;
            const title = (
              <div>
                <h5>!خطا</h5>
                <span>خطایی رخ داده است. مجددا امتحان کنید</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },

    login() {
      // NOTE (m-login) login using username and password
      this.busyLogin = true;
      this.$http
        .post(this.baseUrl + "/setad/authentication/login", {
          mobile: this.username,
          password: md5(this.password),
        })
        .then((res) => {
          if (res.status == 200) {
            localStorage.setItem("userId", res.data.token);

            localStorage.setItem("username", res.data.name);
            localStorage.setItem("role", "researcher");
            this.$route.query.return
              ? this.$router.push(this.$route.query.return)
              : this.$router.push("/researcher/dashboard");
            this.busyLogin = false;
          } else {
            this.busyLogin = false;
            const title = (
              <div>
                <h5>!خطا</h5>
                <span>خطایی رخ داده است. مجددا امتحان کنید</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.busyLogin = false;
        });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.resBack {
  background-image: url("../assets/images/resBack.png");

  background-size: cover;
}
</style>
